import { connect } from 'react-redux';
import { storeSidebarToggled } from '../../store/layoutOptions';
import Menu from './Menu';

const mapStateToProps = state => ({
  sidebarToggled: state.layoutOptions.sidebarToggled,
  completed: state.task.completed,
  path: state.path
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggled: toggled => {
    dispatch(storeSidebarToggled(toggled));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Menu);



// WEBPACK FOOTER //
// ../core/src/components/Menu/index.js